<template>
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :class="editorClasses"
    group="rowcontent"
  >
    <div
      :class="elementClasses"
      class="py-12"
      :style="elementStyles"
    >
      <draggable
        class="wf-flex wf-w-full wf-flex-row wf-flex-wrap"
        v-model="columns"
        group="componentcolumns"
        handle=".component-column-handle"
      >
        <EditorComponentColumn
          @mouseover="childHover = true"
          @mouseleave="childHover = false"
          v-for="column in columns" :key="column.id"
          :parentModule="parentModule"
        />
      </draggable>
      <EditorOptions
        parent="row"
        v-show="hover && ! childHover & ! previewMode"
        :options="menuOptions"
        :parentModule="parentModule"
      />
    </div>
  </div>
</template>

<script>
  import { ConstantsParser } from '../ConstantsParser'
  import EditorElement from '../contracts/EditorElement'
  import EditorComponentColumn from './EditorComponentColumn'
  export default EditorElement.extend({
    props: {
      parentModule: {
        type: String,
        required: false
      }
    },
    components: {EditorComponentColumn},
    computed: {
      elementClasses() {
        if (this.previewMode) {
          return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(this.classes, this.device)).parse()]
        }
        let displayClasses = []
        let classes = Object.keys(this.classes).reduce((carry, device) => {
          let deviceDisplayClass = this.classes[device].find(deviceClass => deviceClass.property == 'Display')
          if (deviceDisplayClass) {
            let opacity = 'wf-opacity-100'
            let prefix = ''
            if (device === 'tablet') {
              prefix = 'sm:'
            }
            if (device === 'desktop') {
              prefix = 'lg:'
            }
            if (deviceDisplayClass.value == 'NONE') {
              opacity = 'wf-opacity-50'
            }
            displayClasses.push(`${prefix}${opacity}`)
          }
          let deviceObject = {}
          let deviceClasses = this.classes[device].filter(deviceClass => deviceClass.property != 'Display')
          this.$set(deviceObject, device, deviceClasses)
          return {...carry, ...deviceObject}
        }, {})
        return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(classes, this.device)).parse(), ...displayClasses]
      },
      module() {
        return 'componentRowModule'
      },
      parent() {
        return this.$parent.$parent
      },
      pageComponentIndex() {
        return this.parent.pageComponentIndex
      },
      family() {
        return 'rows'
      },
      sectionIndex() {
        return this.parent.sectionIndex
      },
      rowIndex() {
        return this.parent.rowIndex
      },
      columnIndex() {
        return this.parent.columnIndex
      },
      componentIndex() {
        return this.parent.componentIndex
      },
      componentSectionIndex() {
        return this.parent.componentSectionIndex
      },
      componentRowIndex() {
        let element = {
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
          componentSection: this.componentSectionIndex
        }
        if (this.pageComponentIndex !== null && this.pageComponentIndex !== undefined) {
          element = {
            pageComponent: this.pageComponentIndex,
            componentSection: this.componentSectionIndex
          }
        }
        if (this.parent.parent.parentModule) {
          element = {
            layoutPageComponent: this.pageComponentIndex,
            componentSection: this.componentSectionIndex
          }
        }
        return this.$store.getters[`${this.module}/index`](element, this.id, this.parentModule)
      },
      styles() {
        return this.$store.getters[`${this.module}/styles`](this.element, 'styles', this.parentModule)
      },
      properties() {
        return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule)
      },
      classes() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'classes', this.parentModule)
      },
      customClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'customClasses', this.parentModule)
      },
      constantClasses() {
        return []
      },
      columns: {
        get() {
          return this.$store.getters['componentColumnModule/elements'](this.element, this.parentModule)
        },
        set(value) {
          this.$store.dispatch('componentColumnModule/updateOrder', {...this.element, value, parentModule: this.parentModule})
        },
      },
    },
  })
</script>